import { render, staticRenderFns } from "./Divisoes.vue?vue&type=template&id=7803036c&scoped=true&"
import script from "./Divisoes.vue?vue&type=script&lang=js&"
export * from "./Divisoes.vue?vue&type=script&lang=js&"
import style0 from "./Divisoes.vue?vue&type=style&index=0&id=7803036c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7803036c",
  null
  
)

export default component.exports